import { FormStore } from '@roc/feature-app-core';
import { GlobalStore } from '@roc/feature-app-core';
import { action, makeObservable, observable, override } from 'mobx';
import { OneToolService } from '../../services/oneToolService';
import { formatDate } from '@roc/feature-utils';
import { EmailAddress } from '@roc/ui/formComponents';

const REQUIRED_MESSAGE = 'This field is required.';

const form = {
  fields: {
    name: {
      value: '',
      error: null,
      rule: 'required',
      message: REQUIRED_MESSAGE,
    },
    contactName: {
      value: '',
      error: null,
      rule: 'required',
      message: REQUIRED_MESSAGE,
    },
    cellPhone: {
      value: '',
      error: null,
      rule: 'required|regex:/^\\d{3}-?\\d{3}-?\\d{4}$/|alpha_dash',
      message: 'Phone must be a number with the format xxx-xxx-xxxx.',
    },
    emailAddress: {
      value: '',
      error: null,
      rule: 'required|email',
      attribute: 'email address',
    },
    address: {
      value: null,
      error: null,
      rule: [{ required_if_true: ['isPreflight', 'hasNewAddress'] }],
      message: REQUIRED_MESSAGE,
    },
  },
  meta: {
    key: null,
    editMode: false,
    isValid: false,
    error: null,
  },
};
export class InsuranceFormStore extends FormStore {
  private globalStore: GlobalStore;

  showInsuranceDialog: boolean;

  constructor(globalStore) {
    super({ ...form }, globalStore);
    this.globalStore = globalStore;
    makeObservable(this, {
      showInsuranceDialog: observable,
      reset: override,
      openDialog: action,
      closeDialog: action,
      saveInsurance: action,
    });
  }

  reset() {
    super.reset();
    this.showInsuranceDialog = false;
  }

  openDialog() {
    this.showInsuranceDialog = true;
  }
  closeDialog() {
    this.showInsuranceDialog = false;
  }

  saveInsurance() {
    if (this.runFormValidationWithMessage()) {
      this.showInsuranceDialog = false;
    }
  }
}
